export default {
  "pwaNotificationList.thead.no": "#NO",
  "pwaNotificationList.thead.taskId": "TaskId",
  "pwaNotificationList.thead.id": "ID",
  "pwaNotificationList.thead.bindSiteKey": "BindSiteKey",
  "pwaNotificationList.thead.title": "Title",
  "pwaNotificationList.thead.content": "Content",
  "pwaNotificationList.thead.url": "Url",
  "pwaNotificationList.thead.resultData": "ResultData",
  "pwaNotificationList.thead.taskStatus": "TaskStatus",
  "pwaNotificationList.thead.host": "Host",
  "pwaNotificationList.thead.channel": "Channel",
  "pwaNotificationList.thead.endpoint": "Endpoint",
  "pwaNotificationList.thead.createdBy": "CreatedBy",
  "pwaNotificationList.thead.updatedBy": "UpdatedBy",
  "pwaNotificationList.thead.createTime": "CreateTime",
  "pwaNotificationList.thead.modifyTime": "ModifyTime",
  "pwaNotificationList.title": "PWA Notification List",
  "pwaNotificationList.action.reSend": "ReSend",
  "pwaNotificationList.action.details": "Details",
  "pwaNotificationList.action.delete": "Delete",
  "pwaNotificationList.action.add": "Add",
  "pwaNotificationList.modal.title.details": "Notification Details",
  "pwaNotificationList.modal.title.add": "Send Message",
  "pwaNotificationList.modal.title.edit": "Edit Notification",
  "pwaNotificationList.confirm.delete.title": "Delete Notification",
  "pwaNotificationList.confirm.delete.content": "Are you sure you want to delete this notification?",
  "pwaNotificationList.confirm.resend.title": "ReSend Notification",
  "pwaNotificationList.confirm.resend.content": "Are you sure you want to resend this notification?",
  "pwaNotificationList.message.copySuccess": "Copy Success!",
  "pwaNotificationList.message.deleteSuccess": "Delete Success!",
  "pwaNotificationList.message.resendSuccess": "Resend Success!",
  "pwaNotificationList.message.addSuccess": "Add Success!",
  "pwaNotificationList.message.updateSuccess": "Update Success!",
};